import axiosPlataformaClient from '../../../plugins/axios.plataforma.plugin';

export default {
  create({ enrollmentId, topicId }) {
    return axiosPlataformaClient.custAxios().post(`/content/topic/${topicId}/enrollment/${enrollmentId}/progress`);
  }
};
